export default __webpack_public_path__ + "static/RobotoCondensed-Regular-db6d916952fb988edac1e531d47ff83a.ttf";